import React from "react"
import PropTypes from "prop-types";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import './styles/_call-to-action-common.module.scss';

const CallToActionBlogBottom = (props) => {
    const { t } = useTranslation('common');
    const title = t('callToActionBlogBottom.title');
    return <>
        <section className={`call-to-action`}>
            <div className={'container'}>
                <div className={'inner-wrapper'} >
                    <div className={'inner-child'}>
                        <h2 dangerouslySetInnerHTML={{ __html: title.replace(/\n/g, '<br/>') }}></h2>
                        <div className={"d-flex"}>
                            <Link href={"https://middlewarepublic.slack.com/join/shared_invite/zt-39l76rpo6-ZNGfpA_4U_kYL6oTuYAgmQ"} target={"_blank"}><button className={"ahref-btn primary"}>{t('callToActionBlogBottom.joinSlack')}</button></Link>
                            <Link href={"https://app.middleware.io/auth/register/"} target={"_blank"}><button className={"ahref-btn secondary"}>{t('callToActionBlogBottom.getStartedFree')}</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'bg-section'}>
                {/* <img src={props.img} alt={"Middleware CTA Image"} width={670} height={172} loading="lazy"/> */}
            </div>
        </section>
    </>
}
CallToActionBlogBottom.defaultProps = {
    title: "Optimize More. Worry Less. With Middleware.",
    description: "Completely free, no strings attached. Solve problems at their source and see it in action today!",
    img: "/images/blog/blog-cta-home-670.webp"
}

CallToActionBlogBottom.propTypes = {
    title:PropTypes.string,
    description:PropTypes.string,
    img: PropTypes.string
}
export default CallToActionBlogBottom